import http from '@/utils/http';

// 获取游戏列表
export const getHokPVPSpeed: (params: object) => Promise<any> = (params) => {
  return http({
    url: '/api/v1/dashboard/info/pvp',
    method: 'post',
    // errorHandler: true,
    data: {
      ...params
    }
  });
};
